// Copyright (C) 2020 Markus Peloso
//
// This file is part of osm-app-component.
//
// osm-app-component is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as
// published by the Free Software Foundation, either version 3 of the
// License, or (at your option) any later version.
//
// osm-app-component is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with osm-app-component.  If not, see <http://www.gnu.org/licenses/>.

export const funding: { [code: string]: string } = {
  en: `https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=JFWXTYPKBD2YA&source=url`,
  de: `https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=LZB5LRD2MBQUS&source=url`
};
